const NotFoundPage = (props) => {
    return (
        <div>
            Not found
        </div>
    );
};

export default NotFoundPage;